import styled from 'styled-components';

export const NotificationContainer = styled.div`
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translate(-50%, -30px);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }

  .notification-new-btn {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
    margin-top: 15px;
    transition: margin-top 0.3s ease;
    animation: slideDown 0.3s ease forwards;
  }
  .hide-notification-btn {
    display: none;
  }
  .notification-btn {
    display: flex;
  }
  .MuiBox-root {
    padding: 8px;
    box-sizing: border-box;
    position: sticky;
    top: 55px;
    z-index: 1;
    background: ${({ theme }) => theme.Bg1};
    @media screen and (max-width: 599px) {
      padding: 4px 0 8px 4px;
    }
  }
  .notification-content {
    padding: 0px 8px;
  }
  .notification-unseen-bg {
    background: ${({ theme }) => theme.lightBlue};
  }
  .notification-user-item {
    display: flex;
    padding: 12px 8px;
    border-bottom: 1px solid ${({ theme }) => theme.border1};
    position: relative;
    min-height: 50px;
    .notification-user-details {
      margin-left: 8px;
      width: calc(100% - 80px);
      align-items: center;
      .notification-displayName {
        font-size: 14px;
        margin-bottom: 4px;
      }
      .notification-username {
        font-size: 14px;
        color: #828282;
      }
    }
  }
  .notification-img-container {
    width: 50px;
    display: flex;
    justify-content: center;
  }
  .notification-company-logo {
    width: 50px;
    height: 50px;
    border: 1px solid ${({ theme }) => theme.border1};
    border-radius: 4px;
    position: absolute;
    top: 38px;
    left: 7px;
  }
  .notification-apply-company-logo {
    width: 50px;
    height: 50px;
    border: 1px solid ${({ theme }) => theme.border1};
    border-radius: 4px;
  }
  .notification-sample-company-logo {
    path,
    line {
      stroke: #828282;
    }
  }
  .notification-message-container {
    font-size: 14px;
    font-weight: 500;
    display: flex;
    width: calc(100% - 65px);
    white-space: nowrap;
    @media only screen and (max-width: 599px) {
      width: calc(100% - 25px);
      display: inherit;
      white-space: normal;
    }
    .notification-message {
      margin-right: 4px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  .notification-description {
    border-radius: 2px;
    position: relative;
  }
  .notification-post-description {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: ${({ theme }) =>
      theme.mode === 'light' ? '#304756' : '#a0acb4'} !important;
    a,
    span,
    strong,
    p {
      all: unset;
      margin: 0;
      font-size: 14px;
      color: ${({ theme }) =>
        theme.mode === 'light' ? '#304756' : '#a0acb4'} !important;
      background-color: transparent !important;
    }
    ol {
      margin: 0;
    }
  }
  .notification-comment {
    font-size: 14px;
    background-color: ${({ theme }) => theme.fieldDisable1};
    border: 1px solid ${({ theme }) => theme.border1};
    padding: 2px 6px;
    border-radius: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    width: fit-content;
  }
  .notification-created-at {
    @media only screen and (max-width: 599px) {
      right: 10px;
      bottom: 10px;
      top: inherit;
    }
    font-size: 13px;
    color: #828282;
    white-space: nowrap;
    position: absolute;
    right: 40px;
    top: 15px;
  }
  .notification-menu-container {
    position: absolute;
    right: 7px;
    top: 10px;
    box-sizing: border-box;
    button svg {
      fill: ${({ theme }) => theme.svg1};
    }
  }
  .notification-post-btn {
    padding: 0px 10px;
    font-size: 13px;
    margin-top: 4px;
  }
  .notification-follow-message {
    font-weight: 500;
  }
  .notification-follow-username {
    font-size: 14px;
    color: #828282;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
  }
`;

export const NotificationMenuContainer = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.red1};
  .notification-menu-item {
    display: flex;
    padding: 10px 18px 10px 16px;
    align-items: center;
    cursor: pointer;
    border-radius: 2px;
    width: 110px;
    position: relative;
    &:hover {
      background-color: ${({ theme }) => theme.lightGrayHover};
    }
    .notification-delete-icon {
      width: 20px;
      height: 20px;
      fill: ${({ theme }) => theme.red1};
      margin-right: 8px;
    }
    .notification-circular-icon {
      position: absolute;
      right: 8px;
    }
  }
`;
